"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SingleCurrencyCarDetailsContainer_1 = require("./CarDetailsContainer/SingleCurrencyCarDetailsContainer");
var MultiCurrencyCarDetailsContainer_1 = require("./CarDetailsContainer/MultiCurrencyCarDetailsContainer");
var CarDetailsContainer = function (props) {
    var _a;
    var isMultiCurrency = props.isMultiCurrency, carDetails = props.carDetails;
    var handleChangeConfiguration = react_1.useCallback(function () {
        var _a;
        if (carDetails.car.configurationSourceUrl) {
            window.location.href = (_a = carDetails.car.startConfigurationSourceUrl, (_a !== null && _a !== void 0 ? _a : carDetails.car.configurationSourceUrl));
            return;
        }
        throw new Error('There is no configurationSourceUrl set!');
    }, [(_a = carDetails) === null || _a === void 0 ? void 0 : _a.configurationSourceUrl]);
    if (isMultiCurrency) {
        return <MultiCurrencyCarDetailsContainer_1.default {...props} changeConfiguration={handleChangeConfiguration}/>;
    }
    return <SingleCurrencyCarDetailsContainer_1.default {...props} changeConfiguration={handleChangeConfiguration}/>;
};
exports.default = CarDetailsContainer;
